import {
  features,
  faqs,
  footerNavigation,
  testimonials,
} from './contentSections';
import Hero from './components/Hero';
import Clients from './components/Clients';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { Helmet } from 'react-helmet-async';

export default function LandingPage() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://optimistic-news.com" />
        <title>Optimistic News - Discover Uplifting Stories</title>
        <meta
          name="description"
          content="Discover uplifting and positive news stories curated daily. Get optimistic perspectives on world events, technology, science, and human progress."
        />
      </Helmet>
      <div className="bg-white dark:text-white dark:bg-boxdark-2">
        <div className="isolate dark:bg-boxdark-2">
          <Hero />
          <Clients />
          <Features features={features} />
          <Testimonials testimonials={testimonials} />
          <FAQ faqs={faqs} />
        </div>
        <Footer footerNavigation={footerNavigation} />
      </div>
    </>
  );
}
